import { z } from 'zod';
const toolSchemaBuilder = (schema) => ({
    /**
     * Extends the basic schema with the given fields
     */
    extend: (fields) => toolSchemaBuilder(schema.extend(fields)),
    /**
     * Adds a page number to the schema, this is useful for tools that rely on pagination
     */
    withPagination: () => toolSchemaBuilder(schema.extend({
        // We need to coerce because LLMs were passing strings instead of numbers quite often (via MCP)
        page: z.coerce
            .number()
            .positive()
            .nullable()
            .describe('Use this to paginate through the results'),
    })),
    /**
     * Builds the schema
     */
    build: () => schema,
    /**
     * Returns the zod schema so far
     */
    schema,
});
function createToolSchema({ type, description, version, }) {
    return toolSchemaBuilder(z
        .object({
        type: z.literal(version !== undefined
            ? `${type}_v${version}`
            : type),
    })
        .describe(description));
}
export { createToolSchema };
//# sourceMappingURL=toolSchemaBuilder.js.map